import { FC, useState } from "react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";
import { Enterprise1, Enterprise2, Enterprise3 } from "../../../assets/images";

const testimonialData = [
  {
    image: Enterprise1,
    name: "Steve Okoye",
    role: "CEO",
    company: "Dexlabs",
  },
  {
    image: Enterprise2,
    name: "Bunmi Joshua",
    role: "Head of Aquisition",
    company: "Jaiz Bank",
  },
  {
    image: Enterprise3,
    name: "James Moses",
    role: "Project manager",
    company: "Venture Capital",
  },
];

export const TestimonialSection: FC = () => {
  const [index, setIndex] = useState(0);

  const goToPrev = () => {
    setIndex((prev) => (prev === 0 ? testimonialData.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setIndex((prev) => (prev === testimonialData.length - 1 ? 0 : prev + 1));
  };

  const { image, name, role, company } = testimonialData[index];

  return (
    <div className="hidden md:flex w-1/2 h-screen items-center justify-center bg-gray-100 relative">
      <img
        src={image}
        alt="Testimonial"
        className="object-cover object-top h-full w-full absolute top-0 left-0 z-0"
      />
      <div className="z-10 relative p-16 text-white bg-gradient-to-t from-black/80 to-transparent w-full h-full flex flex-col justify-end">
        <p className="text-2xl lg:text-4xl font-semibold font-satoshi leading-snug">
          Bnkle Has helped me get my construction projects{" "}
          <span className="text-[#A1BAED]">delivered on time</span> and with
          optimal quality.
        </p>
        <div className="mt-6 flex items-center justify-between">
          <div>
            <p className="text-base lg:text-2xl font-satoshi text-white font-semibold">
              {name}
            </p>
            <p className="text-xs lg:text-base font-medium font-satoshi text-white">
              {role}{" "}
              <span className="text-xs lg:text font-regular font-satoshi text-bidsbg">
                {company}
              </span>
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={goToPrev}
              aria-label="Previous testimonial"
              disabled={index === 0}
              className={`w-6 h-6 transition-opacity ${
                index === 0 ? "opacity-30 cursor-not-allowed" : "cursor-pointer"
              }`}
            >
              <TbChevronLeft className="w-6 h-6 cursor-pointer" />
            </button>
            <button
              onClick={goToNext}
              aria-label="Next testimonial"
              className={`w-6 h-6 transition-opacity ${
                index === testimonialData.length - 1
                  ? "opacity-30 cursor-not-allowed"
                  : "cursor-pointer"
              }`}
              disabled={index === testimonialData.length - 1}
            >
              <TbChevronRight className="w-6 h-6 cursor-pointer" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
